export default __webpack_public_path__ + "static/media/ExpireIcon.ebfb69ce.svg";